<template>
  <v-dialog
    v-model="open"
    max-width="400"
    persistent
  >
    <v-card
      :prepend-icon="icon"
      :title="title"
      :text="message"
    >
      <template v-slot:actions>
        <v-spacer />

        <template v-if="dialogType === 'confirm'">
          <v-btn variant="text" @click="close">No</v-btn>
          <v-btn color="primary" @click="confirm">Yes</v-btn>
        </template>

        <v-btn
          v-else
          color="primary"
          @click="close"
        >
          CLOSE
        </v-btn>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'CommonDialog',

  computed: {
    open: {
      get() {
        return this.$store.state.dialogOpen
      },
      set() {
        this.$store.dispatch('closeDialog')
      }
    },
    title() {
      return this.$store.state.dialogTitle
    },
    message() {
      return this.$store.state.dialogMessage
    },
    icon() {
      return this.$store.state.dialogIcon
    },
    dialogType() {
      return this.$store.state.dialogType || 'info'
    }
  },

  methods: {
     confirm() {
      const cb = this.$store.state.dialogOnConfirm
      this.close()
      cb && cb()
    },
    
    close() {
      this.$store.dispatch('closeDialog')
    }
  }
}
</script>
